export function usePreviousRoute() {
	if (import.meta.server) { return }
	return window.history.state.back
}
